import { useEffect, useState } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import { setErrorToast, setSuccessToast } from '../../actions'
import { SET_R_V_REQUEST_OPEN } from './ReportViewerReducer'
import { GET_APP_SETTING_BY_NAME } from '../../requests'
import format from 'date-fns/format'
import isAfter from 'date-fns/isAfter'

const ReportViewerController = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const { requestOpen } = useSelector((state) => state.reportViewer, shallowEqual)
  const { appUserRights } = useSelector((state) => state.auth, shallowEqual)
  const [reportViewerWindow, setReportViewerWindow] = useState(null)
  const [clearOldAfterDays, setClearOldAfterDays] = useState(0)
  const [populateOnEnvelopeCompletion, setPopulateOnEnvelopeCompletion] = useState(false)

  useEffect(() => {
    if (requestOpen) {
      if (appUserRights.includes('ViewImages')) {
        dispatch({ type: SET_R_V_REQUEST_OPEN, requestOpen: false })
        if (
          !location.pathname.includes('/report-viewer') &&
          !location.pathname.includes('/image-viewer') &&
          !(reportViewerWindow && !reportViewerWindow.closed)
        ) {
          const newWindow = window.open(
            `/report-viewer`,
            '_blank',
            `menubar=no,width=${window.screen.width / 1.5},height=${window.screen.height}`
          )
          if (newWindow) {
            newWindow.moveTo(window.screen.width / 1.5, 0)
            setReportViewerWindow(newWindow)
            if (populateOnEnvelopeCompletion)
              dispatch(
                setSuccessToast('The reports in the list will be cleared when the Report Viewer window is closed.')
              )
            else if (clearOldAfterDays > 0)
              dispatch(setSuccessToast(`Reports remain in viewer for ${clearOldAfterDays} days`))
          } else {
            dispatch(setErrorToast('Failed to Open Report Viewer. Is Popup blocker enabled?'))
          }
        }
      } 
    }
  }, [requestOpen, location])

  useEffect(() => {
    const handleTabClose = (ev) => {
      if (reportViewerWindow && !reportViewerWindow.closed) {
        reportViewerWindow.close()
      }
    }
    window.addEventListener('beforeunload', handleTabClose)
    return () => window.removeEventListener('beforeunload', handleTabClose)
  }, [reportViewerWindow])

  useEffect(() => {
    GET_APP_SETTING_BY_NAME(
      'PopulateReportViewerOnEnvelopeCompletion',
      (data) => {
        setPopulateOnEnvelopeCompletion(String(data.VALUE).toLowerCase() === 'true')
      },
      (e) => {
        console.error(e)
        setPopulateOnEnvelopeCompletion(false)
      }
    )
  }, [])

  useEffect(() => {
    GET_APP_SETTING_BY_NAME(
      'ReportViewerClearOldAfterDays',
      (data) => {
        const days = Number(data.VALUE)
        if (days > 0) {
          const clearDate = new Date(format(new Date(), 'MM/dd/yyyy'))
          let storageList = JSON.parse(localStorage.getItem('REPORTS_LIST')) || []

          clearDate.setDate(clearDate.getDate() - days)

          storageList = storageList.filter((pdfInfo) => {
            if (!pdfInfo.reportDate) return true
            const reportDate = new Date(pdfInfo.reportDate)
            return isAfter(reportDate, clearDate)
          })

          setClearOldAfterDays(days)
          localStorage.setItem('REPORTS_LIST', JSON.stringify(storageList))
        }
      },
      (e) => {
        console.error(e)
      }
    )
  }, [])

  return null
}

export default ReportViewerController
